import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private _keys: string[] = [];
  constructor() {}

  set(key: string, value: any) {
    this._keys.push(key);
    localStorage.setItem(key, value);
  }
  get(key: string): any {
    return localStorage.getItem(key);
  }

  remove(key: string) {
    localStorage.removeItem(key);
    this._keys.splice(this._keys.indexOf(key), 1);
  }

  clear() {
    this._keys.forEach((key) => {
      this._keys.splice(this._keys.indexOf(key), 1);
      localStorage.removeItem(key);
    });
  }
}
